var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLocationCity = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "40px",
    viewBox: "0 0 38 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "AE1559C1-932B-4092-89D0-78F0CBAADF91")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-770.000000, -378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy",
    transform: "translate(299.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(15.100000, 13.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography",
    transform: "translate(152.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-Outlined-/-Social-/-location_city",
    transform: "translate(0.900000, 0.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Social-/-location_city"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25,22.9166667 L31.25,10.4166667 L25,4.16666667 L18.75,10.4166667 L18.75,14.5833333 L6.25,14.5833333 L6.25,43.75 L43.75,43.75 L43.75,22.9166667 L31.25,22.9166667 Z M14.5833333,39.5833333 L10.4166667,39.5833333 L10.4166667,35.4166667 L14.5833333,35.4166667 L14.5833333,39.5833333 Z M14.5833333,31.25 L10.4166667,31.25 L10.4166667,27.0833333 L14.5833333,27.0833333 L14.5833333,31.25 Z M14.5833333,22.9166667 L10.4166667,22.9166667 L10.4166667,18.75 L14.5833333,18.75 L14.5833333,22.9166667 Z M27.0833333,39.5833333 L22.9166667,39.5833333 L22.9166667,35.4166667 L27.0833333,35.4166667 L27.0833333,39.5833333 Z M27.0833333,31.25 L22.9166667,31.25 L22.9166667,27.0833333 L27.0833333,27.0833333 L27.0833333,31.25 Z M27.0833333,22.9166667 L22.9166667,22.9166667 L22.9166667,18.75 L27.0833333,18.75 L27.0833333,22.9166667 Z M27.0833333,14.5833333 L22.9166667,14.5833333 L22.9166667,10.4166667 L27.0833333,10.4166667 L27.0833333,14.5833333 Z M39.5833333,39.5833333 L35.4166667,39.5833333 L35.4166667,35.4166667 L39.5833333,35.4166667 L39.5833333,39.5833333 Z M39.5833333,31.25 L35.4166667,31.25 L35.4166667,27.0833333 L39.5833333,27.0833333 L39.5833333,31.25 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationCity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location_city.f9334ed5.svg";
export { ForwardRef as ReactComponent };